import { Assert } from '@team/assert';
import { normalizeError } from '@team/error';

if (Assert.isUndefined(window.OffscreenCanvas)) {
  class OffscreenCanvasPolyfill {
    #canvas: HTMLCanvasElement;

    constructor(width: number, height: number) {
      this.#canvas = document.createElement('canvas');
      this.#canvas.width = width;
      this.#canvas.height = height;
    }

    convertToBlob(options?: ImageEncodeOptions): Promise<Blob> {
      return new Promise<Blob>((resolve, reject) => {
        try {
          this.#canvas.toBlob(
            (blob) => {
              if (Assert.isNull(blob)) {
                reject(new Error('Failed to convert canvas to blob'));

                return;
              }

              resolve(blob);
            },
            options?.type,
            options?.quality
          );
        } catch (error) {
          reject(normalizeError(error));
        }
      });
    }

    get width(): number {
      return this.#canvas.width;
    }

    set width(value: number) {
      this.#canvas.width = value;
    }

    get height(): number {
      return this.#canvas.height;
    }

    set height(value: number) {
      this.#canvas.height = value;
    }

    getContext(contextId: string, options?: unknown) {
      return this.#canvas.getContext(contextId, options);
    }

    addEventListener(
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ): void {
      this.#canvas.addEventListener(type, listener, options);
    }

    removeEventListener(
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | EventListenerOptions
    ): void {
      this.#canvas.removeEventListener(type, listener, options);
    }

    dispatchEvent(event: Event): boolean {
      return this.#canvas.dispatchEvent(event);
    }
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  window.OffscreenCanvas = OffscreenCanvasPolyfill;
}
